import { Model } from "./model";

export class BaseModel extends Model {
  id = "";
  isDeleted = false;
  isConstant?: boolean = false; // if IsConstant - API will not allow to set "IsDeleted"
}
